import { useState, useEffect, useContext } from "react";
import Sidebar from "../../shared/components/sidebar/Sidebar";
import Navbar from "../../shared/components/navbar/Navbar";
import { useHttpClient } from "../../shared/hooks/http-hook";
import "./Stock.scss";
import moment from "moment";

import { AuthContext } from "../../shared/context/auth-context";
import { ClinicaContext } from "../../shared/context/clinica-context";

// Componentes novos
import StockDashboard from "./components/StockDashboard";
import AdvancedSearch from "./components/AdvancedSearch";
import ModalDescarteStock from "./components/ModalDescarteStock";
import ModalGestaoArmazens from "./components/ModalGestaoArmazens";

//MUI
import Button from "@mui/material/Button";

import {
  Package,
  Pencil,
  LayoutDashboard,
  Table2,
  RefreshCw,
  CircleX,
  Download,
  Repeat,
  PlusCircle,
} from "lucide-react";

import ModalAdicionarNoStock from "./components/ModalAdicionarNoStock";
import ModalStockRetirada from "./components/ModalStockRetirada";
import ModalHistoricoMovimentos from "./components/ModalHistoricoMovimentos";
import ModalEditarProduto from "./components/ModalEditarProduto";

import { Tabs, Tab } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";

import ModalTransferenciaStock from "./components/ModalTransferenciaStock";

import { DataGrid } from "@mui/x-data-grid";
import { useLoading } from "../../shared/context/LoadingContext";
//Antd
import { Popover, Space } from "antd";
import toast from "react-hot-toast";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  Switch,
} from "@mui/material";

import TextField from "@mui/material/TextField";
import ModalRetiradaAtendimento from "./components/ModalRetiradaAtendimento";
import {
  formatarDataGuardada,
  diasAteDataGuardada,
} from "../../shared/util/datasGuardadas";

function Stock() {
  const { startLoading, stopLoading } = useLoading();

  const [rows, setRows] = useState([]);
  const [stock, setStock] = useState();
  const [categoriasStock, setCategoriasStock] = useState();
  const [permaStock, setPermaStock] = useState();
  const [openModal, setOpenModal] = useState("");
  const { sendRequest } = useHttpClient();
  const [stockRetirada, setStockRetirada] = useState();
  const [categoriesTree, setCategoriesTree] = useState([]);
  const [dadosModalEditar, setDadosModalEditar] = useState({});
  const [activeTab, setActiveTab] = useState(0);

  const [dadosDescarte, setDadosDescarte] = useState(null);
  const [openSaftDialog, setOpenSaftDialog] = useState(false);
  const [openExportDialog, setOpenExportDialog] = useState(false);
  const [exportarPorCategoria, setExportarPorCategoria] = useState(false);
  const [anoSaft, setAnoSaft] = useState(new Date().getFullYear());
  const [acaoSaft, setAcaoSaft] = useState("baixar");
  const [stockTransferencia, setStockTransferencia] = useState(null);
  const [totalLocalizacoesClinica, setTotalLocalizacoesClinica] = useState(0);

  const [stockEntrada, setStockEntrada] = useState(null);

  const [armazens, setArmazens] = useState([]);
  const [localizacoes, setLocalizacoes] = useState([]);

  const [filtrosActivos, setFiltrosActivos] = useState(null);

  /* Lotes esgotados de produtos que AINDA TÊM stock não apareciam em lado
     nenhum: a tabela mostra só os lotes ativos quando existe algum, e o filtro
     «esgotados» só entra em produtos com quantidade total a zero. Um lote
     lançado por engano num produto com stock ficava invisível — e portanto
     impossível de eliminar. O backend já sabia responder a isto
     (`includeEmptyLots=true`), só não havia como lho pedir. */
  const [mostrarLotesEsgotados, setMostrarLotesEsgotados] = useState(false);

  const auth = useContext(AuthContext);
  const clinica = useContext(ClinicaContext);

  const [lotesEsgotadosDetalhes, setLotesEsgotadosDetalhes] = useState({
    produto: null,
    lotes: [],
  });

  useEffect(() => {
    fetchData(false);
  }, [sendRequest, clinica.clinica._id, auth.token]);

  const fetchData = async (includeEmptyLots = false) => {
    startLoading();
    try {
      const [
        stockResponse,
        categoriasStockResponse,
        localizacoesResponse,
        armazensResponse,
      ] = await Promise.all([
        sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/stocks/clinica/${clinica.clinica._id}?includeEmptyLots=${includeEmptyLots}`,
          "GET",
          null,
          { Authorization: "Bearer " + auth.token },
        ),
        sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/categoriasstock/clinica/${clinica.clinica._id}`,
          "GET",
          null,
          { Authorization: "Bearer " + auth.token },
        ),
        sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/localizacoes/clinica/${clinica.clinica._id}`,
          "GET",
          null,
          { Authorization: "Bearer " + auth.token },
        ),
        sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/armazens/clinica/${clinica.clinica._id}`,
          "GET",
          null,
          { Authorization: "Bearer " + auth.token },
        ),
      ]);

      // Process stock data
      if (stockResponse && stockResponse.stock) {
        const tempRows = processStockData(stockResponse.stock.stock);
        setRows(tempRows);
        setPermaStock(stockResponse.stock);
        setStock(stockResponse.stock);
      } else {
        setRows([]);
        setPermaStock(null);
        setStock(null);
      }

      // Process categories data
      if (categoriasStockResponse && categoriasStockResponse.categoriasStock) {
        const tree = buildCategoryTree(categoriasStockResponse.categoriasStock);
        setCategoriesTree(tree);
        setCategoriasStock(categoriasStockResponse.categoriasStock);
      } else {
        setCategoriesTree([]);
        setCategoriasStock([]);
      }

      if (localizacoesResponse?.localizacoes) {
        const locsAtivas = localizacoesResponse.localizacoes.filter(
          (l) => l.ativo,
        );
        setTotalLocalizacoesClinica(locsAtivas.length);
        setLocalizacoes(locsAtivas);
      }

      if (armazensResponse?.armazens) {
        setArmazens(armazensResponse.armazens.filter((a) => a.ativo));
      }
    } catch (err) {
      console.error("err", err);
    } finally {
      stopLoading();
    }
  };

  // Helper function
  const buildCategoryTree = (categories, parentId = null) => {
    if (!categories || !Array.isArray(categories)) return [];

    return categories
      .filter((category) => {
        if (parentId === null) {
          return (
            category.categoriaPai === null ||
            category.categoriaPai === undefined
          );
        }
        return category.categoriaPai === parentId;
      })
      .map((category) => ({
        ...category,
        subcategorias: buildCategoryTree(categories, category.id),
      }));
  };

  const processStockData = (stockData) => {
    let totalByProduct = {};
    let rows = [];

    stockData.forEach((st) => {
      st.lotes.forEach((lote, index) => {
        // Criar o objeto row como você já faz
        const row = {
          id: `${st._id}-${lote._id}`,
          produto: st.produto.nome,
          unidadeMedida: st.produto.unidadeMedida,
          produtoRetirado: st.produto.comRetirada,
          stock: lote.quantidade,
          qtdIdeal: st.quantidadeIdeal,
          produtoID: st.produto._id,
          categoriaProduto: st.produto.categoriaStock,
          lote: lote.lote,
          dataValidade: lote.dataValidade,
          isFirstLot: index === 0,
          // Campos atualizados
          classificacao: st.produto.classificacao || "PA",
          fornecedor: lote.fornecedor,
          precoCompra: lote.precoCompra || 0,
          localizacoes: lote.localizacoes || [],
          localizacaoOrigemId:
            lote.localizacoes?.find((l) => l.quantidade > 0)?.localizacao
              ?._id || null,
          autoGerado: lote.autoGerado || false,
          dataImportacao: lote.dataImportacao,
          esgotado: lote.esgotado || false,
          dataEsgotamento: lote.dataEsgotamento,
        };

        // Adicionar estas duas linhas para preservar as propriedades especiais
        if (lote.isResumoLotesEsgotados) {
          row.isResumoLotesEsgotados = lote.isResumoLotesEsgotados;
          row.lotesEsgotadosDetalhes = lote.lotesEsgotadosDetalhes;
        }

        rows.push(row);

        // Calcular total apenas para lotes não esgotados
        if (!lote.esgotado) {
          totalByProduct[st.produto._id] =
            (totalByProduct[st.produto._id] || 0) + lote.quantidade;
        }
      });
    });

    // Add total to each row
    rows = rows.map((row) => ({
      ...row,
      total: totalByProduct[row.produtoID],
    }));

    return rows;
  };

  useEffect(() => {
    if (stock) {
      setRows(processStockData(stock.stock));
    }
  }, [stock]);

  const handleCloseModal = () => {
    setOpenModal("");
    setDadosModalEditar({});
  };

  /* Um só sítio a montar o pedido da procura. Havia três cópias deste
     `formData` e cada campo novo tinha de ser acrescentado nas três — foi
     assim que o `includeEmptyLots` ficou de fora e o interruptor apagava os
     filtros. O valor vem por argumento, e não do estado, porque quem carrega
     no interruptor precisa de procurar com o valor NOVO: o estado ainda tem o
     antigo nesse instante. */
  const procurarComFiltros = async (filtros, incluirEsgotados, baseStock) => {
    const formData = new FormData();
    formData.append("nome", filtros.nome);
    formData.append("categoriaStock", filtros.categoriaStock);
    formData.append("estoqueStatus", filtros.estoqueStatus);
    formData.append("validadeStatus", filtros.validadeStatus);
    formData.append("armazem", filtros.armazem || "todos");
    formData.append("localizacao", filtros.localizacao || "todas");
    formData.append("includeEmptyLots", String(incluirEsgotados));

    const base = baseStock || permaStock;

    try {
      const responseData = await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/stocks/buscarProdutos/${clinica.clinica._id}`,
        "POST",
        formData,
        { Authorization: "Bearer " + auth.token },
      );

      setStock(
        responseData?.produtos
          ? { ...base, stock: responseData.produtos }
          : base,
      );
    } catch (err) {
      setStock(base);
    }
  };

  const atualizarStock = async (novoStock, mensagem) => {
    setPermaStock(novoStock);
    toast.success(mensagem);

    /* Com filtros ativos, a procura manda — e leva o interruptor com ela. */
    if (filtrosActivos) {
      await procurarComFiltros(
        filtrosActivos,
        mostrarLotesEsgotados,
        novoStock,
      );
      return;
    }

    /* Sem filtros e com os esgotados à vista, a resposta do endpoint não
       serve: vem passada pelo `lotesParaMostrar`, que os esconde. Voltar a
       pedir é o que mantém a lista igual ao que se estava a ver. */
    if (mostrarLotesEsgotados) {
      fetchData(true);
      return;
    }

    setStock(novoStock);
  };

  /* Recarregar sem perder o que se estava a ver.
   *
   * Quem edita um produto não recebe o stock atualizado de volta — o endpoint
   * das validades responde só com uma mensagem —, por isso é preciso voltar a
   * pedir. O que estava a ser feito era `fetchData(false)`, e isso traz a lista
   * COMPLETA: a procura que estivesse aplicada desaparecia, e o interruptor dos
   * lotes esgotados voltava a desligado. Quem estava a corrigir validades
   * produto a produto perdia o filtro a cada gravação e tinha de o repetir.
   *
   * Aqui refaz-se o mesmo caminho por que a lista tinha chegado ao ecrã: os
   * dados de base com o interruptor como está, e a procura por cima se houver
   * alguma. */
  const recarregarMantendoVista = async () => {
    await fetchData(mostrarLotesEsgotados);

    if (filtrosActivos) {
      await procurarComFiltros(filtrosActivos, mostrarLotesEsgotados);
    }
  };

  const handleFazerRetirada = (stId, localizacaoOrigemId) => {
    const id = stId.split("-")[0];
    const produtoSelecionado = stock.stock.find((st) => st._id === id);
    const nomeLote = produtoSelecionado.lotes.find(
      (l) => l._id === stId.split("-")[1],
    ).lote;
    setStockRetirada({
      selecionado: produtoSelecionado,
      nomeLote,
      localizacaoOrigemId,
    });
    setOpenModal("stockRetirada");
  };

  const handleFazerTransferencia = (stId, localizacaoOrigemId) => {
    const id = stId.split("-")[0];
    const produtoSelecionado = stock.stock.find((st) => st._id === id);
    const nomeLote = produtoSelecionado.lotes.find(
      (l) => l._id === stId.split("-")[1],
    ).lote;
    setStockTransferencia({
      selecionado: produtoSelecionado,
      nomeLote,
      localizacaoOrigemId,
    });
    setOpenModal("transferencia");
  };

  const handleDarEntrada = (row) => {
    const stockItem = stock.stock.find(
      (st) => st.produto._id === row.produtoID,
    );
    if (stockItem) {
      setStockEntrada(stockItem);
      setOpenModal("entrada");
    }
  };

  const handleAdvancedSearch = async (filters) => {
    const temFiltros =
      filters.nome ||
      filters.categoriaStock !== "todas" ||
      filters.estoqueStatus !== "todos" ||
      filters.validadeStatus !== "todos" ||
      filters.armazem !== "todos" ||
      filters.localizacao !== "todas";

    if (!temFiltros) {
      setFiltrosActivos(null);
      setStock(permaStock);
      return;
    }

    setFiltrosActivos(filters);
    startLoading();
    try {
      await procurarComFiltros(filters, mostrarLotesEsgotados);
    } catch (err) {
      console.error("Erro na busca avançada:", err);
      toast.error("Erro ao realizar busca");
    } finally {
      stopLoading();
    }
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);

    // Se estiver indo para o dashboard (tab 1), buscar dados completos incluindo lotes esgotados
    if (newValue === 1) {
      fetchData(true);
    } else {
      // De volta à tabela, respeitar o interruptor dos esgotados em vez de o
      // ignorar — trocar de separador e voltar não deve desfazer a escolha.
      fetchData(mostrarLotesEsgotados);
    }
  };

  const handleToggleLotesEsgotados = async (checked) => {
    setMostrarLotesEsgotados(checked);

    /* Com filtros ativos, o interruptor tem de passar pela procura. Ir buscar
       o stock inteiro aqui era o que fazia a lista voltar a mostrar tudo,
       esgotado ou não, deitando a procura fora sem avisar. */
    if (filtrosActivos) {
      startLoading();
      try {
        await procurarComFiltros(filtrosActivos, checked);
      } finally {
        stopLoading();
      }
      return;
    }

    fetchData(checked);
  };

  /* Estado de reposição do PRODUTO (não do lote): o total soma os lotes por
     esgotar e compara-se com o mínimo. Um produto pode ter este lote cheio e
     mesmo assim estar abaixo do mínimo — por isso a conta é feita no total.

     Devolve null quando não há mínimo definido: sem mínimo não há como dizer
     que o stock é baixo, e pintar a linha de encarnado seria uma invenção. */
  const estadoDeStock = (row) => {
    const minimo = Number(row.qtdIdeal);
    if (!Number.isFinite(minimo) || minimo <= 0) return null;

    const total = Number(row.total) || 0;
    if (total <= 0) return "esgotado";
    if (total < minimo) return "baixo";
    return null;
  };

  const getRowClassName = (params) => {
    const estado = estadoDeStock(params.row);
    if (estado === "esgotado") return "stock-row__sem-stock";
    if (estado === "baixo") return "stock-row__danger";

    const validade = params.row.dataValidade;
    if (validade) {
      const daysUntilExpiry = diasAteDataGuardada(validade);
      if (daysUntilExpiry !== null) {
        if (daysUntilExpiry <= 0) return "stock-row__expired";
        if (daysUntilExpiry <= 30) return "stock-row__expiring-soon";
      }
    }
    return "";
  };

  const handleOpenModalEditar = (dados) => {
    setDadosModalEditar({
      open: true,
      id: dados.produtoID,
      qtdIdeal: dados.qtdIdeal,
    });
  };

  const handleDescarteStock = (row) => {
    // Encontrar informações detalhadas do produto e lote
    const stockItem = stock.stock.find(
      (item) => item.produto._id === row.produtoID,
    );

    const loteInfo = stockItem?.lotes.find(
      (lote) => lote._id === row.id.split("-")[1],
    );

    const categoriaFiltrada = categoriasStock.find(
      (categoria) => categoria._id === stockItem.produto.categoriaStock,
    );

    if (stockItem && loteInfo) {
      setDadosDescarte({
        produtoInfo: {
          ...stockItem.produto,
          categoriaStock: categoriaFiltrada,
        },
        loteInfo: loteInfo,
      });
      setOpenModal("descarte");
    } else {
      toast.error("Não foi possível encontrar detalhes do produto/lote.");
    }
  };

  const columns = [
    {
      field: "produto",
      headerName: "Produto",
      flex: 2.5,
      renderCell: (params) => {
        /* O tom da linha sozinho não chega: é um fundo a 10% que se perde num
           ecrã claro, e não diz porquê. A etiqueta diz o estado por palavras e
           o tooltip dá os números que o justificam. */
        const estado = estadoDeStock(params.row);

        return (
          <div className="stock-product-cell">
            <Tooltip title={params.value}>
              <span className="stock-product-name">{params.value}</span>
            </Tooltip>
            {params.row.classificacao === "MP" && (
              <span className="stock-product-tag">Matéria Prima</span>
            )}
            {estado && (
              <Tooltip
                title={`Total do produto: ${params.row.total || 0} · mínimo: ${
                  params.row.qtdIdeal
                }`}
              >
                <span
                  className={`stock-alerta stock-alerta--${
                    estado === "esgotado" ? "sem-stock" : "baixo"
                  }`}
                >
                  {estado === "esgotado" ? "Sem stock" : "Stock baixo"}
                </span>
              </Tooltip>
            )}
          </div>
        );
      },
    },
    {
      field: "stock",
      headerName: "Qtd",
      flex: 0.5,
      type: "number",
      renderCell: (params) => {
        return params.value;
      },
    },
    {
      field: "qtdIdeal",
      headerName: "Stock Min",
      flex: 1,
      type: "number",
      renderCell: (params) => {
        return params.value;
      },
    },
    {
      field: "unidadeMedida",
      headerName: "Medida",
      flex: 1,
      type: "number",
      renderCell: (params) => {
        return (
          <span style={{ marginRight: "auto" }}>
            {params.row.unidadeMedida}
          </span>
        );
      },
    },
    {
      field: "lote",
      headerName: "Lote",
      flex: 2,
      renderCell: (params) => {
        // Verifica se é um meta-lote (resumo de lotes esgotados)
        if (params.row.isResumoLotesEsgotados) {
          return (
            <div className="lote-cell lote-esgotados-resumo">
              {/* <span className="lote-esgotados-label">{params.value}</span> */}
              <Tooltip title="Ver detalhes dos lotes esgotados">
                <Button
                  size="small"
                  variant="outlined"
                  color="error"
                  onClick={() => handleExpandLotesEsgotados(params.row)}
                  className="lote-esgotados-button"
                >
                  Ver detalhes
                </Button>
              </Tooltip>
            </div>
          );
        }

        // Renderização normal para lotes regulares
        return (
          <div className="lote-cell">
            <Tooltip title={params.value}>
              <span>{params.value}</span>
            </Tooltip>
            {params.row.autoGerado && (
              <Tooltip title="Lote gerado automaticamente">
                <RefreshCw className="lote-auto-icon" size={16} />
              </Tooltip>
            )}
            {params.row.esgotado && (
              <Tooltip title="Lote esgotado">
                <span className="lote-esgotado-badge">Esgotado</span>
              </Tooltip>
            )}
          </div>
        );
      },
    },
    {
      field: "dataValidade",
      headerName: "Validade",
      flex: 1,
      // Ver datasGuardadas.js: a validade é um dia, lê-se em UTC. O
      // `.add(1, "day")` que aqui estava só acertava numa das duas formas
      // gravadas na base e mostrava a outra um dia à frente.
      valueGetter: (params) =>
        params.value ? formatarDataGuardada(params.value) : "N/A",
      renderCell: (params) => {
        if (!params.value) return "N/A";
        const daysUntilExpiry = moment(params.value, "DD/MM/YYYY").diff(
          moment().startOf("day"),
          "days",
        );
        let color = "inherit";
        if (daysUntilExpiry <= 30) color = "orange";
        if (daysUntilExpiry <= 0) color = "red";
        return <span style={{ color }}>{params.value}</span>;
      },
    },
    {
      field: "fornecedor",
      headerName: "Fornecedor",
      flex: 1.5,
      valueGetter: (params) =>
        params.row.fornecedor && params.row.fornecedor.nome
          ? params.row.fornecedor.nome
          : "N/A",
      renderCell: (params) => {
        return params.value !== "N/A" ? (
          <Tooltip title={params.value}>
            <span>{params.value}</span>
          </Tooltip>
        ) : (
          "-"
        );
      },
    },
    {
      field: "precoCompra",
      headerName: "Preço",
      flex: 1,
      valueGetter: (params) =>
        params.row.precoCompra && params.row.precoCompra > 0
          ? `${params.row.precoCompra.toLocaleString("pt-BR")}`
          : "N/A",
      renderCell: (params) => {
        return params.value !== "N/A" ? params.value : "-";
      },
    },
    {
      field: "localizacoes",
      headerName: "Localizações",
      flex: 1.5,
      renderCell: (params) => {
        const locs = params.row.localizacoes || [];
        if (locs.length === 0) return "N/A";
        return (
          <Tooltip
            title={locs
              .map(
                (l) =>
                  `${l.localizacao?.armazem?.codigo || "N/A"}/${l.localizacao?.codigo || "N/A"}: ${l.quantidade}`,
              )
              .join(", ")}
          >
            <span>
              {locs
                .map(
                  (l) => `${l.localizacao?.codigo || "N/A"}: ${l.quantidade}`,
                )
                .join(" | ")}
            </span>
          </Tooltip>
        );
      },
    },
    {
      field: "total",
      headerName: "Total",
      flex: 0.5,
      type: "number",
      renderCell: (params) => {
        // Remover a condição isFirstLot
        return params.value;
      },
    },
    {
      field: "action",
      headerName: "Ações",
      flex: 2,
      renderCell: (params) => {
        const content = (
          <div className="dots__menu__popup">
            {auth.perm.includes("u-stR") && (
              <div
                className="popOverMenu--option"
                onClick={handleOpenModalEditar.bind(null, params.row)}
              >
                <span>Editar</span>
                <Pencil className="popOverMenu--option__icon" size={16} />
              </div>
            )}

            {auth.perm.includes("d-st") &&
              !params.row.isResumoLotesEsgotados && (
                <div
                  className="popOverMenu--option"
                  onClick={handleDescarteStock.bind(null, params.row)}
                >
                  <span>Descarte</span>
                  <CircleX
                    className="popOverMenu--option__icon"
                    size={16}
                    style={{ color: "#d32f2f" }}
                  />
                </div>
              )}

            {auth.perm.includes("u-stR") &&
              params.row.stock > 0 &&
              totalLocalizacoesClinica > 1 && (
                <div
                  className="popOverMenu--option"
                  onClick={() =>
                    handleFazerTransferencia(
                      params.row.id,
                      params.row.localizacaoOrigemId,
                    )
                  }
                >
                  <span>Transferir</span>
                  <Repeat
                    className="popOverMenu--option__icon"
                    size={16}
                    style={{ color: "#1976d2" }}
                  />
                </div>
              )}

            {auth.perm.includes("c-st") && (
              <div
                className="popOverMenu--option"
                onClick={() => handleDarEntrada(params.row)}
              >
                <span>Dar entrada</span>
                <PlusCircle
                  className="popOverMenu--option__icon"
                  size={16}
                  style={{ color: "#2e7d32" }}
                />
              </div>
            )}

            {/* {!params.row.produtoRetirado && auth.perm.includes("d-st") && (
              <Popconfirm
                title="Excluir Produto"
                description={`Excluir ${params.row.produto} do stock?`}
                icon={<ErrorIcon style={{ color: "red" }} />}
                okText="Sim"
                cancelText="Não"
                onConfirm={apagarProdutoDoStock.bind(
                  null,
                  params.row.produtoID
                )}
              >
                <div className="popOverMenu--option">
                  <span>Apagar</span>
                  <DeleteIcon className="popOverMenu--option__icon" />
                </div>
              </Popconfirm>
            )} */}
          </div>
        );

        return (
          <>
            {auth.perm.includes("u-stR") && params.row.stock > 0 && (
              <span
                onClick={() =>
                  handleFazerRetirada(
                    params.row.id,
                    params.row.localizacaoOrigemId,
                  )
                }
                className="btn__retiradas"
              >
                Dar Retirada
              </span>
            )}
            {auth.perm.includes("c-st") && params.row.stock === 0 && (
              <span className="btn__esgotado">Esgotado</span>
            )}
            {(auth.perm.includes("u-stR") || auth.perm.includes("d-st")) && (
              <Space wrap>
                <Popover content={content} trigger="click" placement="bottom">
                  <div className="dots__menu">
                    <div className="dot"></div>
                    <div className="dot"></div>
                    <div className="dot"></div>
                  </div>
                </Popover>
              </Space>
            )}
          </>
        );
      },
    },
  ];

  const handleExpandLotesEsgotados = (row) => {
    // Extrair detalhes dos lotes esgotados
    const lotesEsgotados = row.lotesEsgotadosDetalhes;

    /* `row.produto` é só o NOME do produto — o `processStockData` achata-o para
       string. Guardava-se aqui tal e qual e o título da janela lia
       `produto.nome` de uma string, portanto dizia «undefined». Guardamos o
       essencial em objeto, que é também o que a eliminação de lote precisa. */
    setOpenModal("lotesEsgotados");
    setLotesEsgotadosDetalhes({
      produto: {
        _id: row.produtoID,
        nome: row.produto,
        unidadeMedida: row.unidadeMedida,
        categoriaStock: row.categoriaProduto,
      },
      lotes: lotesEsgotados,
    });
  };

  /* Um lote esgotado não aparece na tabela (é pedida com `includeEmptyLots=false`)
     e no filtro «esgotados» vem colapsado numa linha-resumo sem menu. Esta
     janela é o único sítio onde eles se veem um a um, por isso é aqui que a
     eliminação tem de estar. Reaproveita o modal do descarte, que ao receber um
     lote a zero passa sozinho a modo de eliminação. */
  const handleEliminarLoteEsgotado = (lote) => {
    const produto = lotesEsgotadosDetalhes.produto;
    const categoriaFiltrada = categoriasStock.find(
      (categoria) => categoria._id === produto.categoriaStock,
    );

    setDadosDescarte({
      produtoInfo: { ...produto, categoriaStock: categoriaFiltrada },
      loteInfo: lote,
    });
    setOpenModal("descarte");
  };

  const handleGerarSaft = async () => {
    if (!anoSaft || anoSaft < 2000 || anoSaft > 2100) {
      toast.error("Por favor, insira um ano válido");
      return;
    }

    startLoading();
    try {
      if (acaoSaft === "baixar") {
        // Gerar e baixar
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_LINK}/api/stocks/gerar-saft/${clinica.clinica._id}?ano=${anoSaft}`,
          {
            method: "GET",
            headers: {
              Authorization: "Bearer " + auth.token,
            },
          },
        );

        if (!response.ok) {
          throw new Error("Erro ao gerar SAF-T");
        }

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `SAFT-CV-${clinica.clinica.nome}-${anoSaft}.xml`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);

        toast.success("SAF-T gerado com sucesso!");
      } else {
        // Gerar e enviar para eFatura
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_LINK}/api/stocks/enviar-saft/${clinica.clinica._id}?ano=${anoSaft}`,
          {
            method: "POST",
            headers: {
              Authorization: "Bearer " + auth.token,
            },
          },
        );

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.message || "Erro ao enviar SAF-T");
        }

        const data = await response.json();
        toast.success(
          data.message || "SAF-T enviado com sucesso para eFatura!",
        );
      }

      setOpenSaftDialog(false);
    } catch (err) {
      console.error("Erro com SAF-T:", err);
      toast.error(err.message || "Erro ao processar SAF-T");
    } finally {
      stopLoading();
    }
  };

  const handleExportarExcel = async () => {
    startLoading();
    try {
      const url = `${process.env.REACT_APP_BACKEND_LINK}/api/stocks/exportar-excel/${clinica.clinica._id}?separadoPorCategoria=${exportarPorCategoria}`;
      const response = await fetch(url, {
        headers: { Authorization: "Bearer " + auth.token },
      });
      if (!response.ok) throw new Error("Erro ao exportar");
      const blob = await response.blob();
      const a = document.createElement("a");
      a.href = window.URL.createObjectURL(blob);
      a.download = `stock-${new Date().toISOString().split("T")[0]}.xlsx`;
      a.click();
      window.URL.revokeObjectURL(a.href);
      toast.success("Stock exportado com sucesso!");
      setOpenExportDialog(false);
    } catch (err) {
      toast.error("Erro ao exportar stock");
    } finally {
      stopLoading();
    }
  };

  return (
    <>
      <div className="new">
        <Sidebar />
        <div className="newContainer">
          <Navbar title="Stock" icon={Package} />
          <div className="stock__container caixa">
            <div className="stock__header">
              <div className="stock__header__container1">
                {auth.perm.includes("c-st") && (
                  <Button
                    variant="contained"
                    color="success"
                    className="stock__entrada-btn"
                    onClick={(e) => setOpenModal("adicionar")}
                  >
                    Fazer entrada no stock
                  </Button>
                )}
                {auth.perm.includes("r-histSt") && (
                  <>
                    <span
                      className="stock__header__historico-btn"
                      onClick={(e) => setOpenModal("historicoMovimentos")}
                    >
                      Histórico de Movimentos
                    </span>
                    <Button
                      variant="outlined"
                      color="primary"
                      startIcon={<Download size={18} />}
                      onClick={() => setOpenSaftDialog(true)}
                      className="stock__saft-btn"
                    >
                      Gerar SAF-T
                    </Button>

                    <Button
                      variant="outlined"
                      color="success"
                      startIcon={<Download size={18} />}
                      onClick={() => setOpenExportDialog(true)}
                    >
                      Exportar Excel
                    </Button>
                  </>
                )}
                {auth.perm.includes("u-stR") && (
                  <Button
                    variant="contained"
                    color="warning"
                    onClick={() => setOpenModal("retiradaAtendimento")}
                  >
                    Retirada por Atendimento
                  </Button>
                )}
                {auth.perm.includes("u-stR") && (
                  <Button
                    variant="outlined"
                    onClick={() => setOpenModal("gestaoArmazens")}
                  >
                    Gerir Armazéns
                  </Button>
                )}
              </div>
            </div>

            {/* Tabs para alternar entre Dashboard e Tabela */}
            <Tabs
              value={activeTab}
              onChange={handleTabChange}
              className="stock__tabs"
              indicatorColor="primary"
              textColor="primary"
            >
              <Tab icon={<Table2 size={18} />} label="Tabela de Produtos" />
              <Tab icon={<LayoutDashboard size={18} />} label="Dashboard" />
            </Tabs>

            {/* Busca avançada */}
            {activeTab === 0 && (
              <AdvancedSearch
                onSearch={handleAdvancedSearch}
                categoriasStock={categoriesTree}
                armazens={armazens}
                localizacoes={localizacoes}
              />
            )}

            {/* «Todos os lotes» e não «mostrar esgotados»: desligado, ainda se
                veem lotes esgotados — os de produtos que esgotaram por
                inteiro, que a lista mostra à mesma para o produto não
                desaparecer. O que este interruptor faz é deixar de esconder
                seja o que for. */}
            {activeTab === 0 && (
              <Tooltip title="Desligado, os lotes esgotados de produtos que ainda têm stock ficam escondidos">
                <FormControlLabel
                  sx={{ ml: 0.5 }}
                  control={
                    <Switch
                      size="small"
                      checked={mostrarLotesEsgotados}
                      onChange={(e) =>
                        handleToggleLotesEsgotados(e.target.checked)
                      }
                    />
                  }
                  label="Mostrar todos os lotes"
                />
              </Tooltip>
            )}

            {/* Conteúdo com base na Tab selecionada */}
            {activeTab === 1 && permaStock && (
              <StockDashboard
                stock={permaStock}
                categoriasStock={categoriasStock}
              />
            )}

            {activeTab === 0 && rows && (
              <div style={{ height: 500, width: "100%" }}>
                <DataGrid
                  autoWidth
                  className="datagridStock"
                  rows={rows}
                  columns={columns}
                  getRowClassName={getRowClassName}
                  autoPageSize
                  getRowSpacing={(params) => ({
                    top: params.isFirstVisible ? 0 : 5,
                    bottom: params.isLastVisible ? 0 : 5,
                  })}
                />
              </div>
            )}

            {/* Modais */}
            {openModal === "adicionar" && (
              <ModalAdicionarNoStock
                sendRequest={sendRequest}
                clinicaId={clinica.clinica._id}
                auth={auth}
                handleCloseModalAdicionarStock={handleCloseModal}
                open={openModal === "adicionar"}
                atualizarStock={atualizarStock}
                stock={permaStock}
                categoriasStock={categoriasStock}
              />
            )}

            {openModal === "stockRetirada" && (
              <ModalStockRetirada
                sendRequest={sendRequest}
                handleCloseModalStockRetirada={handleCloseModal}
                open={openModal === "stockRetirada"}
                atualizarStock={atualizarStock}
                stock={permaStock}
                dadosProdutoFiltrado={stockRetirada}
                auth={auth}
                clinica={clinica}
              />
            )}

            {openModal === "historicoMovimentos" && (
              <ModalHistoricoMovimentos
                open={openModal === "historicoMovimentos"}
                handleClose={handleCloseModal}
                sendRequest={sendRequest}
                clinicaId={clinica.clinica._id}
              />
            )}

            {dadosModalEditar.open && (
              <ModalEditarProduto
                sendRequest={sendRequest}
                handleCloseModalEditar={handleCloseModal}
                open={dadosModalEditar.open}
                id={dadosModalEditar.id}
                qtdIdeal={dadosModalEditar.qtdIdeal}
                clinicaId={clinica.clinica._id}
                auth={auth}
                categoriasStock={categoriasStock}
                recarregar={recarregarMantendoVista}
              />
            )}
          </div>
        </div>
      </div>
      {openModal === "lotesEsgotados" && (
        <Dialog
          open={openModal === "lotesEsgotados"}
          onClose={handleCloseModal}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle>
            Lotes Esgotados - {lotesEsgotadosDetalhes.produto.nome}
          </DialogTitle>
          <DialogContent>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Lote</TableCell>
                    <TableCell>Data Esgotamento</TableCell>
                    <TableCell>Fornecedor</TableCell>
                    <TableCell>Localizações</TableCell>
                    {auth.perm.includes("d-st") && (
                      <TableCell align="right">Ações</TableCell>
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {lotesEsgotadosDetalhes.lotes.map((lote) => (
                    <TableRow key={lote._id}>
                      <TableCell>{lote.lote}</TableCell>
                      <TableCell>
                        {lote.dataEsgotamento
                          ? moment(lote.dataEsgotamento).format("DD/MM/YYYY")
                          : "Não registrado"}
                      </TableCell>
                      <TableCell>{lote.fornecedor?.nome || "N/A"}</TableCell>
                      <TableCell>
                        {lote.localizacoes.map(
                          (l, indice) =>
                            l.localizacao?.armazem?.codigo +
                            ":" +
                            l.localizacao?.codigo +
                            `${lote.localizacoes.length > 1 && indice < lote.localizacoes.length - 1 ? " | " : ""}`,
                        ) || "N/A"}
                      </TableCell>
                      {auth.perm.includes("d-st") && (
                        <TableCell align="right">
                          <Tooltip title="Eliminar o lote, se foi lançado por engano">
                            <Button
                              size="small"
                              color="error"
                              onClick={() => handleEliminarLoteEsgotado(lote)}
                            >
                              Eliminar
                            </Button>
                          </Tooltip>
                        </TableCell>
                      )}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseModal} color="primary">
              Fechar
            </Button>
          </DialogActions>
        </Dialog>
      )}
      {openModal === "descarte" && dadosDescarte && (
        <ModalDescarteStock
          open={openModal === "descarte"}
          handleClose={handleCloseModal}
          dados={dadosDescarte}
          sendRequest={sendRequest}
          stockId={permaStock?.id}
          atualizarStock={atualizarStock}
        />
      )}
      {openModal === "retiradaAtendimento" && (
        <ModalRetiradaAtendimento
          open={openModal === "retiradaAtendimento"}
          handleClose={handleCloseModal}
          sendRequest={sendRequest}
          auth={auth}
          clinicaId={clinica.clinica._id}
          stock={permaStock}
          atualizarStock={atualizarStock}
        />
      )}
      {openModal === "transferencia" && stockTransferencia && (
        <ModalTransferenciaStock
          open={openModal === "transferencia"}
          handleClose={handleCloseModal}
          stock={permaStock}
          dadosProdutoFiltrado={stockTransferencia}
          sendRequest={sendRequest}
          auth={auth}
          clinica={clinica}
          atualizarStock={atualizarStock}
        />
      )}

      {openModal === "entrada" && stockEntrada && (
        <ModalAdicionarNoStock
          sendRequest={sendRequest}
          clinicaId={clinica.clinica._id}
          auth={auth}
          handleCloseModalAdicionarStock={handleCloseModal}
          open={openModal === "entrada"}
          atualizarStock={atualizarStock}
          stock={permaStock}
          categoriasStock={categoriasStock}
          produtoInicial={stockEntrada}
        />
      )}
      {openModal === "gestaoArmazens" && (
        <ModalGestaoArmazens
          open={openModal === "gestaoArmazens"}
          handleClose={handleCloseModal}
          sendRequest={sendRequest}
          clinicaId={clinica.clinica._id}
        />
      )}
      {/* Dialog para gerar SAF-T */}
      <Dialog
        open={openSaftDialog}
        onClose={() => setOpenSaftDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Gerar SAF-T - Inventário</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Ano do Inventário"
            type="number"
            fullWidth
            value={anoSaft}
            onChange={(e) => setAnoSaft(parseInt(e.target.value))}
            inputProps={{ min: 2000, max: 2100 }}
            helperText="Insira o ano fiscal do inventário"
            style={{ marginBottom: "20px" }}
          />

          {/* <FormControl component="fieldset" style={{ marginTop: "10px" }}>
            <FormLabel component="legend">Escolha a ação:</FormLabel>
            <RadioGroup
              value={acaoSaft}
              onChange={(e) => setAcaoSaft(e.target.value)}
            >
              <FormControlLabel
                value="baixar"
                control={<Radio />}
                label="Baixar Arquivo"
              />
              <FormControlLabel
                value="enviar"
                control={<Radio color="success" />}
                label="Enviar para eFatura"
              />
            </RadioGroup>
          </FormControl> */}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenSaftDialog(false)} color="secondary">
            Cancelar
          </Button>
          <Button
            onClick={handleGerarSaft}
            color="primary"
            variant="contained"
            startIcon={<Download size={18} />}
          >
            {acaoSaft === "baixar" ? "Gerar e Baixar" : "Gerar e Enviar"}
          </Button>
        </DialogActions>
      </Dialog>
      {/* Dialog exportar stock em excel */}
      <Dialog
        open={openExportDialog}
        onClose={() => setOpenExportDialog(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Exportar Stock para Excel</DialogTitle>
        <DialogContent>
          <FormControl component="fieldset" style={{ marginTop: "8px" }}>
            <FormLabel component="legend">Organização das sheets:</FormLabel>
            <RadioGroup
              value={exportarPorCategoria ? "sim" : "nao"}
              onChange={(e) =>
                setExportarPorCategoria(e.target.value === "sim")
              }
            >
              <FormControlLabel
                value="nao"
                control={<Radio />}
                label="Todos os produtos numa sheet"
              />
              <FormControlLabel
                value="sim"
                control={<Radio />}
                label="Separado por categoria (uma sheet por categoria)"
              />
            </RadioGroup>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenExportDialog(false)} color="secondary">
            Cancelar
          </Button>
          <Button
            onClick={handleExportarExcel}
            color="success"
            variant="contained"
            startIcon={<Download size={18} />}
          >
            Exportar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default Stock;
